import { ChoixListe } from "@/pages/parametres/ChoixListe";
import { ChampDate } from "./ChampDate";
import { DicteeBouton, ajouterTexte } from "@/components/assistant/DicteeBouton";
export const ChampPerso = ({ def, valeur, onChange }) => {
  const id = `champ-${def.cle}`;
  if (def.type === "case") {
    return (
      <label className="at-soft flex items-center gap-3 px-3 min-h-[44px]" data-testid={id}>
        <input type="checkbox" checked={Boolean(valeur)} onChange={(e) => onChange(e.target.checked)} className="w-5 h-5" style={{ accentColor: "var(--accent)" }} />
        <span className="text-sm font-semibold">{def.libelle}</span>
      </label>
    );
  }
  return (
    <label className="block" data-testid={id}>
      <span className="at-label block mb-1.5">{def.libelle}</span>
      {def.type === "liste" ? (
        <ChoixListe valeur={valeur || "_"} onChange={(v) => onChange(v === "_" ? "" : v)} options={[{ code: "_", label: "—" }, ...def.options.map((o) => ({ code: o, label: o }))]} testId={`${id}-select`} />
      ) : def.type === "date" ? (
        <ChampDate valeur={valeur} onChange={onChange} testId={`${id}-date`} />
      ) : (
        <span className="flex gap-2">
          <input type={def.type === "nombre" ? "number" : "text"} value={valeur ?? ""} onChange={(e) => onChange(e.target.value)} className="at-input" />
          <DicteeBouton testId={`${id}-dictate`} onTexte={(t) => onChange(def.type === "nombre" ? (t.replace(/[^\d,.]/g, "").replace(",", ".") || valeur) : ajouterTexte(valeur, t))} />
        </span>
      )}
    </label>
  );
};

export const valeurChamp = (def, v) => {
  if (v === undefined || v === null || v === "") return "—";
  if (def.type === "case") return v ? "Oui" : "Non";
  if (def.type === "date") return `${v.slice(8, 10)}/${v.slice(5, 7)}/${v.slice(0, 4)}`;
  if (def.type === "nombre") return new Intl.NumberFormat("fr-FR").format(v);
  return v;
};
